import React from "react";
import {priceToString} from "../../util/PriceUtil";
import {Editable, EditableProps} from "./Editable";
import {useEditable} from "./EditableContext";
import {space} from "../../provider_api";
import IPriceProto = space.kenko.proto.IPriceProto;
import PriceProto = space.kenko.proto.PriceProto;

/**
 * First there's a dropdown for the payment policy (prepaid, postpaid, other...)
 *
 * Depending on the first, there is a second input field - either a price or a price category.
 * 
 * TODO -- NOW: make this use a currency and a price. To test out nested editors.
 */
export const EditablePriceField = <EnclosingType extends object>(props: EditableProps<EnclosingType, IPriceProto>) => {

  const {editing, mode, value, setValue} = useEditable(props);

  if (mode == 'create' || (mode == 'update' && editing && !props.immutable)) {
    return <Editable {...props}>
      <input className={'EditableEditing'} 
             type={'number'}
             min={0}
             value={((value?.amount as number ?? 0) / 100)}
             onChange={event => {
               setValue(new PriceProto({
                 currencyCode: 'USD',
                 amount: Math.floor(parseFloat(event.target.value) * 100)
               }))
             }}/>
    </Editable>
  }

  // not editing. 
  return <Editable {...props}>
    <div className={'EditableNotEditing'}>{priceToString(value, true)}</div>
  </Editable>
};